import React from 'react';
import moment from 'moment';
import { MoreMenu } from 'datastake-daf/dist/components';
import { Modal, Tag, Typography, message } from 'antd';

const columns = ({
  t = () => { },
  canEdit,
  removeUser = () => { },
  resendInvite = () => { },
  setUserToEdit = () => { },
  canDelete,
  userRoles = [],
  company = {},
  canCreate = false,
  app
}) => [
  {
    title: t('Name'),
    dataIndex: 'firstName',
    key: 'firstName',
    show: true,
    primarySearch: true,
    width: '20%',
    ellipsis: true,
    render: (v) => <Typography.Text ellipsis={{ tooltip: v }} className="max-w-100">{v}</Typography.Text>,
  },
  {
    title: t('Last Name'),
    dataIndex: 'lastName',
    key: 'lastName',
    show: true,
    ellipsis: true,
    search: true,
    width: '20%',
    render: (v) => <Typography.Text ellipsis={{ tooltip: v }} className="max-w-100">{v}</Typography.Text>,
  },
  {
    title: t('Email'),
    dataIndex: 'email',
    width: '20%',
    key: 'email',
    ellipsis: true,
    show: true,
    search: true,
    render: (v) => <Typography.Text ellipsis={{ tooltip: v }} className="max-w-100">{v}</Typography.Text>,
  },
  {
    title: t('Status'),
    dataIndex: 'status',
    key: 'status',
    width: 120,
    ellipsis: false,
    show: true,
    render: (id, user) => {
      if (user.empty) {
        return null;
      }

      if (user.status === 'inactive') {
        return <Tag color="red">{t("Blocked")}</Tag>
      }

      if (user.approvalStatus === 'approved') {
        return <Tag color="green">{t("Active")}</Tag>
      }

      return <Tag color="orange">{t("Pending")}</Tag>
    }
  },
  {
    title: t('Last Login'),
    dataIndex: 'lastLogin',
    key: 'lastLogin',
    show: true,
    width: 120,
    ellipsis: true,
    render: (id, user) => {
      if (user.empty) {
        return <div className="daf-default-cell" />;
      }

      if (user.lastLogin) {
        return moment(user.lastLogin).format('DD MMM YYYY');
      } else {
        return ''
      }
    }
  },
  {
    title: t('User Role'),
    dataIndex: 'role',
    key: 'role',
    ellipsis: true,
    width: '20%',
    show: true,
    render: (role, user) => {
      if (user.empty) {
        return null;
      }

      const _v = userRoles.find((r) => r.value === role);
      const v = t(_v ? _v.label : typeof role === 'string' ? role : '');

      return (
        <div className="daf-default-cell">
          <Typography.Text className="max-w-100" ellipsis={{ tooltip: v }}>{v}</Typography.Text>
        </div>
      );
    }
  },
  {
    title: t(''),
    key: 'actions',
    width: 60,
    show: canEdit || canDelete,
    render: (row, all) => {
      if (all.empty) {
        return <div className="daf-default-cell" />;
      }

      const _v = userRoles.find((r) => r.value === all.role);

      const items = [
        canDelete ? {
          key: "removeUser",
          disabled: all.isAdmin || _v?.isForAppAdmin,
          onClick: () => {
            Modal.confirm({
              title: t('Are you sure you want to remove this user from your organisation?'),
              onOk: () => removeUser(all.id),
              cancelText: t('No'),
              okText: 'Yes',
              closable: true,
            })
          },
          label: t('Remove User'),
        } : null,
        canEdit ? {
          key: "editPermission",
          onClick: () => setUserToEdit(all),
          disabled: all.isAdmin || _v?.isForAppAdmin,
          label: t('Edit Permissions'),
        } : null,
        all.invitationToken && canCreate ? {
          key: "copyLink",
          onClick: () => {
            navigator.clipboard.writeText(`${window.location.host}/${app}/r/${company.inviteToken}/${all.invitationToken}`);
            message.info({ content: t('Invitation link copied') })
          },
          label: t('Copy Invitation Link'),
        } : null,
        all.invitationToken && canCreate ? {
          key: "resendInvite",
          onClick: () => {
            Modal.confirm({
              title: t('Are you sure you want to invite this user again? This user will receive a new notification'),
              onOk: () => resendInvite(all.id),
              cancelText: t('No'),
              okText: 'Yes',
              closable: true,
            })
          },
          label: t('Resend Invite'),
        } : null,
      ];

      return <MoreMenu items={items} />;
    },
    client: false,
  },
].filter((v) => v.show);

export const emptyDataSource = [
  { id: 1, empty: true },
  { id: 2, empty: true },
  { id: 3, empty: true },
  { id: 4, empty: true },
  { id: 5, empty: true },
  { id: 6, empty: true },
  { id: 7, empty: true },
  { id: 8, empty: true },
  { id: 9, empty: true },
  { id: 10, empty: true },
];

export default columns;
